/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

/*
 * Copyright (c) 2026.
 * Orion Analytics
 */

import React, {useMemo} from "react";

import IndexPerformanceChart
    from "./IndexPerformanceChart";

import GlobalHeatmap
    from "./GlobalHeatmap";

import RiskAppetite
    from "./RiskAppetite";
import MetricAssistant from "../common/MetricAssistant";

export default function GlobalMarkets({
        activeWidget,
        indices
    }) {

    const historicalData = useMemo(() => {

    try {

        return JSON.parse(
            indices.hist_df
        );

    } catch {

        return [];

    }

    }, [indices]);

    if (!indices?.hist_df) {

        return (
            <div className="text-slate-400">
                Loading global data...
            </div>
        );

    }

let content;

    switch (activeWidget) {

        /*
         * =====================================
         * MAJOR INDICES
         * =====================================
         */

        case "Global Indices":

            content= (

                <IndexPerformanceChart
                    indices={historicalData}
                    title="Global Indices"
                    defaultTickers={[
                        "NIFTY 50",
                        "S&P500"
                    ]}
                    allowedTickers={[
                        "NIFTY 50",
                        "BSE",
                        "S&P500",
                        "NASDAQ",
                        "DAX",
                        "FTSE",
                        "CAC40",
                        "Nikkei225",
                        "HANGSENG",
                        "Shanghai_Composite"
                    ]}
                />

            );
        break;

        /*
         * =====================================
         * FOREX
         * =====================================
         */

        case "Currencies":

            content =  (

                <IndexPerformanceChart
                    indices={historicalData}
                    title="Currencies"
                    defaultTickers={[
                        "USDINR",
                        "EURUSD"
                    ]}
                    allowedTickers={[
                        "USDINR",
                        "EURUSD",
                        "GBPUSD",
                        "JPYUSD"
                    ]}
                />

            );
        break;

        /*
         * =====================================
         * COMMODITIES
         * =====================================
         */

        case "Commodities":

            content =  (

                <IndexPerformanceChart
                    indices={historicalData}
                    title="Commodities"
                    defaultTickers={[
                        "Gold",
                        "Silver",
                        "WTI_Crude"
                    ]}
                    allowedTickers={[
                        "Gold",
                        "Silver",
                        "WTI_Crude",
                        "Copper",
                        "Corn",
                        "Wheat"
                    ]}
                />

            );
        break;

        /*
         * =====================================
         * GLOBAL HEATMAP
         * =====================================
         */

        case "Global Heatmap":

            content =  (

                <GlobalHeatmap
                    histData={historicalData}
                />

            );
        break;

        /*
         * =====================================
         * RISK DASHBOARD
         * =====================================
         */

        case "Risk Dashboard":

            content =  (

                <RiskAppetite
                    histData={historicalData}
                />

            );
        break;

        /*
         * =====================================
         * SOVEREIGN BONDS
         * =====================================
         */

        case "Sov Bonds":

            content =  (

                <div
                    className="
                        bg-slate-950
                        border
                        border-slate-800
                        rounded-3xl
                        p-12
                        text-center
                    "
                >

                    <div
                        className="
                            text-4xl
                            mb-4
                        "
                    >
                        🌍
                    </div>

                    <h2
                        className="
                            text-2xl
                            font-semibold
                            text-white
                            mb-3
                        "
                    >
                        Sovereign Bond Monitor
                    </h2>

                    <p
                        className="
                            text-slate-400
                            max-w-xl
                            mx-auto
                        "
                    >
                        Yield curves and government
                        bond analytics for US,
                        Germany, Japan, UK,
                        India and other major
                        economies will be added
                        in a future release.
                    </p>

                    <div
                        className="
                            mt-6
                            inline-flex
                            px-4
                            py-2
                            rounded-xl
                            bg-amber-500/20
                            text-amber-300
                            border
                            border-amber-500/30
                        "
                    >
                        Coming Soon
                    </div>

                </div>

            );
        break;

        default:

            content =  (

                <div
                    className="
                        text-slate-400
                    "
                >
                    Select a Global Market widget
                </div>

            );

    }
return (

    <>
        {content}

        <MetricAssistant
            title="Market Guide"
            context="market"
        />
    </>

);
}